
import { defineComponent, PropType, ref } from 'vue'
import AppDropdown from '@/components/atoms/AppDropdown.vue'
import Confirm from '@/components/modals/Confirm.vue'

import { copyToClipboard } from '../../api/tools'
import { store } from '@/store'

import { Route } from '@/api/tripply/models'
import { getRouteLink } from '@/api/tripply'

export default defineComponent({
  name: 'RouteThumbnail',
  components: { AppDropdown, Confirm },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    mode: String as PropType<'delete'>
  },
  setup(props) {
    const showShareRoute = ref(false)
    const confirmDelete = ref(false)

    function remove() {
      store.route.deleteRoute(props.route.id)
    }
    function copyRouteLink() {
      copyToClipboard(getRouteLink(props.route.id, true))
    }
    function share() {
      store.route.share(props.route.id)
    }
    function goLive() {
      store.route.goLive(props.route.id)
    }
    function endLive() {
      store.route.endLive(props.route.id)
    }

    return { confirmDelete, remove, showShareRoute, copyRouteLink, share, goLive, endLive }
  }
})
